<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>{{ content }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" color="accent" [mat-dialog-close]="true">{{ confirm }}</button>
  <button mat-button type="button" color="warn" mat-dialog-close>{{ dismiss }}</button>
</mat-dialog-actions>
